import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate, useParams } from "react-router-dom";

import PageHeader from "../../../components/ui/pageHeader/PageHeader";
import PageCard from "../../../components/ui/pageCard/PageCard";
import PageLoader from "../../../components/ui/pageLoader/PageLoader";
import OrganizationForm from "../../../components/organizations/OrganizationForm";

import { getOrganizationById } from "../../../redux/features/organizations/organizationSlice";

export default function EditOrganizationPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedOrganization, isLoading } = useSelector(
    (state) => state.organizations,
  );

  useEffect(() => {
    dispatch(getOrganizationById(id));
  }, [dispatch, id]);

  if (isLoading || !selectedOrganization) {
    return <PageLoader title="Organisatie laden..." />;
  }

  return (
    <div className="organizations-page">
      <PageHeader
        eyebrow="POWER"
        title="Organisatie wijzigen"
        description={selectedOrganization.name}
      />

      <PageCard>
        <OrganizationForm
          mode="edit"
          initialData={selectedOrganization}
          onSuccess={() => navigate(`/dashboard/organizations/${id}`)}
          onCancel={() => navigate(`/dashboard/organizations/${id}`)}
        />
      </PageCard>
    </div>
  );
}
